import script from "./NearPersons.vue?vue&type=script&setup=true&lang=js"
export * from "./NearPersons.vue?vue&type=script&setup=true&lang=js"

import "./NearPersons.vue?vue&type=style&index=0&id=3c3c4a65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3c4a65"]])

export default __exports__